import { Shimmer } from '@components';

export const TaskAssigneeLabelLoading = () => {
  return (
    <>
      <Shimmer
        style={{
          height: 32,
          width: '100%',
          borderRadius: 4,
          marginTop: 16,
          marginBottom: 12,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 32,
          width: '100%',
          borderRadius: 4,
          marginTop: 16,
          marginBottom: 12,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 32,
          width: '100%',
          borderRadius: 4,
          marginTop: 16,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </>
  );
};
